import React, { useState } from 'react';
import {InputAdornment,IconButton, TextField} from '@material-ui/core'
import {Visibility, VisibilityOff} from '@material-ui/icons';
import LoginContainer from '../Layout/LoginContainer'
import LoginButton from '../Layout/LoginButton';
import VerifiedEmail from './VerifiedEmail';
import { FORM_ERROR, OTHER_ERROR } from '../../constants/Error';
import config from '../../config/index.json';
import Countdown, { zeroPad } from 'react-countdown';
import { useDispatch, useSelector } from 'react-redux'
import { AUTHENTICATION_FAILED, RESET_ERROR } from '../../constants/Action';
import { AUTHN_TRIGGER_OTP_URL } from '../../constants/Url';
import axios from 'axios';
import Loader from '../../components/Loader';
import { getDirectoryDisplayNameFromId, getLoginContainerTitle } from '../../helpers/utils';

const getExpiryTime = () => {
    return config.resendOTPInMins * 60000;
}

export default function SmsAndRmOTPVerification(props) {
    const authState = useSelector(state => state.auth)
    const directoryName = getDirectoryDisplayNameFromId(authState.directoryId)
    const [state, setState] = useState({
        rmOTP: '',
        otp: '',
        showPassword: 0
    });
    const [timer0, setTimer0] = useState(Date.now() + getExpiryTime());
    const [buttonLoading0, setButtonLoading0] = useState(false);
    const [otpExpired0, setOtpExpired0] = useState(false);
    const [timer1, setTimer1] = useState(Date.now() + getExpiryTime());
    const [buttonLoading1, setButtonLoading1] = useState(false);
    const [otpExpired1, setOtpExpired1] = useState(false);
    const dispatch = useDispatch();

    const ShowPassword = (props)=>{
        return (
            <InputAdornment position="end">
                <IconButton
                    edge="end"
                    onClick={() => {handleClickShowPassword(props.value)}}>
                    {state.showPassword === props.value? <VisibilityOff /> : <Visibility />}
                </IconButton>
            </InputAdornment>
        )
    }

    const triggerOTP0 = (payload) => {
        setButtonLoading0(true)
        dispatch({ type: RESET_ERROR })
        axios.post(AUTHN_TRIGGER_OTP_URL, { credentials: payload, sendSms: true, trigger: "cidm_forgot_password_otp" }).then((response) => {
            setButtonLoading0(false)
            console.log("triggerOTP SMS response :", response);
            if (response.status === 200) {
                setTimer0(Date.now() + getExpiryTime());
                setOtpExpired0(false)
                // dispatch({type: SWITCH_OTP_EXPIRED, payload: false})
            }
        }).catch((error) => {
            setButtonLoading0(false)
            console.log(error)
            dispatch({ type: AUTHENTICATION_FAILED, payload: error })
        })
    }

    const triggerOTP1 = (payload) => {
        setButtonLoading1(true)
        dispatch({ type: RESET_ERROR })
        axios.post(AUTHN_TRIGGER_OTP_URL, { credentials: payload, toRM: true, trigger: "cidm_forgot_password_rm" }).then((response) => {
            setButtonLoading1(false)
            console.log("triggerOTP to RM response :", response);
            if (response.status === 200) {
                setTimer1(Date.now() + getExpiryTime());
                setOtpExpired1(false)
                // dispatch({type: SWITCH_OTP_EXPIRED, payload: false})
            }
        }).catch((error) => {
            setButtonLoading1(false)
            console.log(error)
            dispatch({ type: AUTHENTICATION_FAILED, payload: error })
        })
    }

    const handleClickShowPassword = (value) => {
        setState({
            ...state,
            showPassword: state.showPassword===value?0:value
        })
    }

    const onInputChange = (event)=>{
        setState({
            ...state,
            otp: event.target.value
        })
    }

    const onRMInputChange = (event)=>{
        setState({
            ...state,
            rmOTP: event.target.value
        })
    }

    const onSubmit = (event)=>{
        event.preventDefault();
        props.handlePolicySubmit({
            sms_otp: state.otp,
            manager_mail_otp: state.rmOTP
        })
    }

    const countDownRenderer0 = ({ minutes, seconds, completed }) => {
        if (completed) {
            setOtpExpired0(true);
            return (
                <span>
                    OTP Expired!!
                </span>
            );
        } else {
            // Render a countdown
            return (
                <span>
                    {zeroPad(minutes)}:{zeroPad(seconds)}
                </span>
            );
        }
    };

    const countDownRenderer1 = ({ minutes, seconds, completed }) => {
        if (completed) {
            setOtpExpired1(true);
            return (
                <span>
                    OTP Expired!!
                </span>
            );
        } else {
            // Render a countdown
            return (
                <span>
                    {zeroPad(minutes)}:{zeroPad(seconds)}
                </span>
            );
        }
    };

    const displayPreferedAppHelperText0 = () => {
        return (
                <p style={{ fontSize: '0.75rem', marginTop: '20px', fontWeight: 600, fontFamily: 'Gentona', color: 'rgba(0, 0, 0, 0.54)' }}>
                {!otpExpired0 ?
                    <span>
                        <a>Resend OTP</a> will be enabled in : <Countdown date={timer0} renderer={countDownRenderer0} />
                    </span>
                    :
                    <>
                    {!buttonLoading0 ?
                        <span style={{fontWeight:'bold'}}>
                            <a href="#" onClick={() => triggerOTP0({})}>Resend OTP</a>
                        </span>
                        :
                        <Loader width={30} height={30}/>
                    }
                    </>
                }
                </p>
        );
    };

    const displayPreferedAppHelperText1 = () => {
        return (
                <p style={{ fontSize: '0.75rem', marginTop: '20px', fontWeight: 600, fontFamily: 'Gentona', color: 'rgba(0, 0, 0, 0.54)' }}>
                {!otpExpired1 ?
                    <span>
                        <a>Resend OTP</a> will be enabled in : <Countdown date={timer1} renderer={countDownRenderer1} />
                    </span>
                    :
                    <>
                    {!buttonLoading1 ?
                        <span style={{fontWeight:'bold'}}>
                            <a href="#" onClick={() => triggerOTP1({})}>Resend OTP</a>
                        </span>
                        :
                        <Loader width={30} height={30}/>
                    }
                    </>
                }
                </p>
        );
    };

    return (
        <div className="login-sm-container">
            <LoginContainer title={getLoginContainerTitle("2FA Verification", authState.directoryId)}
                onSubmit={onSubmit} loading={props.loading} action="Submit" errorState={props.errorState && props.errorType === OTHER_ERROR}
                errorCode={props.errorCode}
                errorMessage={props.errorMessage}>
               {props.email && 
                    <VerifiedEmail
                        value={props.email}
                    />
                }
                <TextField
                    id="outlined-full-width"
                    autoComplete='off'
                    inputProps={{
                        startAdornment: <InputAdornment position="start">C-</InputAdornment>,
                        autocomplete: 'off',
                    }}
                    label="OTP sent in SMS"
                    required
                    name='otp'
                    type='password'
                    value={state.otp}
                    onChange={onInputChange}
                    error={props.errorState && props.errorType === FORM_ERROR}
                    helperText={props.errorState && props.errorType === FORM_ERROR ? props.errorMessage : "You must have recieved an SMS with 6 digit OTP."}
                    disabled={props.loading}
                    // inputRef={input => input && input.focus()}
                />
                {displayPreferedAppHelperText0()}
                <TextField
                    id="outlined-full-width"
                    autoComplete='off'
                    inputProps={{
                        startAdornment: <InputAdornment position="start">C-</InputAdornment>,
                        autocomplete: 'off',
                    }}
                    label="OTP sent to Reporting Manager"
                    required
                    name='rmOTP'
                    type='password'
                    value={state.rmOTP}
                    onChange={onRMInputChange}
                    error={props.errorState && props.errorType === FORM_ERROR}
                    helperText={props.errorState && props.errorType === FORM_ERROR ? props.errorMessage : "Your Reporting Manager has recieved a mail with 6 digit OTP."}
                    disabled={props.loading}
                    // inputRef={input => input && input.focus()}
                />
                {displayPreferedAppHelperText1()}
                <LoginButton marginTop='1px' onSubmit={onSubmit} loading={props.loading}>Submit</LoginButton>
            </LoginContainer>
        </div>
    )
}
